<template>
  <div class="text-[13px]">
    <PageHeader :title="title" :breadcrumbs="breadcrumbs">
      <template #bottom>
        <nav class="flex gap-6 px-6 -mb-px" aria-label="Hermes sections">
          <router-link
            v-for="t in tabs"
            :key="t.key"
            :to="{ name: t.route }"
            :class="['py-3 font-medium border-b-2 inline-flex items-center gap-2',
                     t.key === tab ? 'border-primary-500 text-gray-900' : 'border-transparent text-gray-500 hover:text-gray-900']"
          >
            {{ t.label }}
            <span v-if="t.key === 'approvals' && pending" class="rounded-full bg-primary-50 px-2 text-gray-900">{{ pending }}</span>
          </router-link>
        </nav>
      </template>
    </PageHeader>
    <div class="px-8 py-6">
      <component :is="view" :key="$route.fullPath.split('?')[0]" @crumb="crumb = $event" @pending="pending = $event" />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import { API, TABS } from './hermes';
import HermesOverview from './HermesOverview.vue';
import HermesRuns from './HermesRuns.vue';
import HermesRunDetail from './HermesRunDetail.vue';
import HermesTemplates from './HermesTemplates.vue';
import HermesTemplateEditor from './HermesTemplateEditor.vue';
import HermesExecutors from './HermesExecutors.vue';
import HermesExecutorDetail from './HermesExecutorDetail.vue';
import HermesApprovals from './HermesApprovals.vue';
import HermesSchedules from './HermesSchedules.vue';
import HermesScheduleEditor from './HermesScheduleEditor.vue';
import HermesTests from './tests/HermesTests.vue';

const VIEWS = {
  AdminHermesOverview: 'HermesOverview',
  AdminHermesRuns: 'HermesRuns',
  AdminHermesRun: 'HermesRunDetail',
  AdminHermesTemplates: 'HermesTemplates',
  AdminHermesTemplate: 'HermesTemplateEditor',
  AdminHermesExecutors: 'HermesExecutors',
  AdminHermesExecutor: 'HermesExecutorDetail',
  AdminHermesApprovals: 'HermesApprovals',
  AdminHermesSchedules: 'HermesSchedules',
  AdminHermesSchedule: 'HermesScheduleEditor',
  AdminHermesTests: 'HermesTests',
  AdminHermesTestRuns: 'HermesTests',
};

export default {
  name: 'HermesAdmin',
  components: {
    PageHeader, HermesOverview, HermesRuns, HermesRunDetail, HermesTemplates, HermesTemplateEditor,
    HermesExecutors, HermesExecutorDetail, HermesApprovals, HermesSchedules, HermesScheduleEditor, HermesTests,
  },
  data() {
    return { tabs: TABS, pending: 0, crumb: '' };
  },
  computed: {
    tab() {
      return this.$route.meta.hermesTab || 'overview';
    },
    view() {
      return VIEWS[this.$route.name] || 'HermesOverview';
    },
    tabLabel() {
      return (TABS.find((t) => t.key === this.tab) || TABS[0]).label;
    },
    isDetail() {
      return ['AdminHermesRun', 'AdminHermesTemplate', 'AdminHermesExecutor', 'AdminHermesSchedule'].includes(this.$route.name);
    },
    title() {
      if (this.isDetail) return this.crumb || 'Loading…';
      return this.tabLabel;
    },
    breadcrumbs() {
      const base = [{ label: 'Admin Console' }, { label: 'Hermes', to: { name: 'AdminHermesOverview' } }];
      const tab = TABS.find((t) => t.key === this.tab);
      return this.isDetail ? [...base, { label: tab.label, to: { name: tab.route } }] : base;
    },
  },
  watch: {
    '$route.name'() {
      this.crumb = '';
    },
  },
  mounted() {
    this.loadPending();
  },
  methods: {
    async loadPending() {
      try {
        const { data } = await this.$axios.get(`${API}/effects/summary/`);
        this.pending = data.pending || 0;
      } catch {
        this.pending = 0;
      }
    },
  },
};
</script>
